import React, { Component } from "react";
// eslint-disable-next-line
import { BrowserRouter as Router, Route, NavLink } from "react-router-dom";
import GA from "../../components/GA/GA";
import SmoothEvent from '../../components/SmoothAnalytics/'
import "./Home.css";

class Home extends Component {
  constructor(props) {
    super(props);

    this.state = {
      copy: { home: { prices: "" } },
    };
  }

  componentDidMount(props) {
    this.props.changePage("home");
    GA("Page: Home");
    SmoothEvent("pageload");

    fetch("copy.json")
      .then((response) => response.json())
      .then((copy) => this.setState({ copy }));
  }

  render() {
    return (
      <div className="page-container">
        <div className="home-main-container">
          <div className="home-title-container">
            <div className="home-title-background"></div>
            <div className="home-title">
              <h1 className="h1-home">Fairy Clean</h1>
              <h2 className="h2-home">High quality cleaning services</h2>
            </div>
          </div>

          <div className="home-book-cleaner-container">
            <NavLink exact to="/book">
              <div className="home-book-cleaner">Book a Cleaner</div>
            </NavLink>

            <NavLink exact to="/careers">
              <div className="home-become-cleaner">Become a Cleaner</div>
            </NavLink>

            <div className="breaker"></div>
          </div>
        </div>

        <div className="content-container">
          <div className="content-container-background"></div>
          <div className="content-container-content">
            <h3>Who doesn’t want their home to look clean and fresh?</h3>
            <br />
            Cleaning our house is a daunting assignment for most of us.
            <br />
            <br />
            One of the best options is hiring a professional house cleaning service if you don’t have any desire to
            carry out the job.
            <br />
            <br />
            We provide house cleaning, one-off spring cleaning, end of tenancy cleaning and other cleaning services.
            <br />
            <br />
            At the moment we operate in the major part of North London: Barnet, Borehamwood, Cockfosters, Colindale,
            Edgware, Enfield, Finchley, Hadley Wood, Hamstheath, Hendon, Mill Hill, Oakwood, Palmers Green, Southgate,
            Stanmore, Whetstone, Winchmore Hill, Wood Green.
            <br />
            <br />
            <strong>{this.state.copy.home.prices}</strong>
            <br />
            <br />
            <br />
            <div className="home-testimonials">
              Fantastic service, great communication and a really lovely lady - would highly recommend!
              <br />
              <i>&mdash; Candice</i>
              <br />
              <br />
              Really good agency with an excellent and efficient service. I would highly recommend them!
              <br />
              <i>&mdash; Rachel</i>
              <br />
              <br />
              Amazing agency and great standards of cleaning.
              <br />
              <i>&mdash; Tal</i>
              <br />
              <br />
              <div
                className="fb-like"
                data-href="https://m.facebook.com/FairyClean1"
                data-layout="button"
                data-action="like"
                data-size="small"
                data-show-faces="false"
                data-share="true"
              ></div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default Home;



// WEBPACK FOOTER //
// ./src/pages/Home/Home.js